<div class="dialog-content">
    <div class="d-flex flex-column align-items-center justify-content-center mb-4">
        <img src="./assets/icons/info-modal.svg" alt="warning">
    </div>
    <div class="mb-1">
        <p class="text-size-3 mb-0 text-center"><strong>
                ¿Tienes un código promocional?
            </strong> </p>
    </div>
    <div class="mb-4">
        <p class="text-size-2 mb-0 text-center">Antes de continuar con tu compra, verifica si cuentas con un código
            promocional que pueda ofrecerte beneficios adicionales.</p>
    </div>
    <div class="d-flex actions-content">
        <button mat-stroked-button class="font-size-button white-button" color="primary" (click)="continue()">
            Continuar sin código
        </button>
        <button mat-raised-button class="font-size-button blue-button ml-0" color="primary" matDialogClose>
            Regresar al carrito
        </button>
    </div>
</div>